import { useContext, useEffect, useState } from "react";
import { Form } from "react-bootstrap";

import { ProductSubscriptionType } from "../../constants";
import { DataFormFieldContext } from "../../contexts/dataFormFieldContext";
import { InfoToolTip } from "../infoToolTip";
import { FieldDropdown } from "./fieldDropdown";

export const FieldOfferingMultiCheckbox = ({
	fieldData,
	dropdownData = [],
	setFeatures = () => {},
	features = [],
	setValue = () => {},
	isMandatory,
}) => {
	const selectedOffering = dropdownData.find((dd) => fieldData === dd.id);
	const showFeatures = selectedOffering?.productSubscriptionType === ProductSubscriptionType.MachineLockedLicence;

	const multiCheckData = showFeatures
		? selectedOffering?.features?.map((f) => ({
				id: f.id,
				value: f.defaultValue,
				label: f.name,
		  }))
		: null;

	useEffect(() => {
		setFeatures([]);
		if (fieldData && dropdownData) {
			const offering = dropdownData[0];

			if (offering.features && offering.productSubscriptionType === ProductSubscriptionType.MachineLockedLicence) {
				setFeatures(offering.features.filter((f) => f.defaultValue));
			}
		}
	}, []);

	return (
		<>
			<FieldDropdown
				setValue={(data) => {
					setValue(data);
					setFeatures([]);

					const offering = dropdownData.find((dd) => data === dd.id);
					if (offering.features && offering.productSubscriptionType === ProductSubscriptionType.MachineLockedLicence) {
						setFeatures(
							offering.features.filter((f) => f.defaultValue),
						);
					}
				}}
				fieldData={fieldData}
				dropdownData={dropdownData}
				isMandatory={isMandatory}
			/>
			{multiCheckData && multiCheckData.length ? (
				<FieldMultiCheckbox
					title="Features"
					setValue={setFeatures}
					multiCheckData={multiCheckData}
					fieldData={features}
				/>
			) : null}
		</>
	);
};

export const FieldMultiCheckbox = ({
	isDisabled,
	multiCheckData,
	fieldData,
	setValue = () => {},
	title = "",
	// autoFocus,
}) => {
	multiCheckData.forEach((cd) => {
		const foundField = fieldData.find((fd) => fd.id === cd.id);
		cd.value = !!foundField;
	});

	const subSetValue = (id) => (value) => {
		if (value) {
			fieldData.push(multiCheckData.find((md) => md.id === id));
		} else {
			fieldData = fieldData.filter((fd) => fd.id !== id);
		}

		setValue(fieldData);
	};

	// multi-data
	const checkBoxes = multiCheckData.map((mcd) => (
		<FieldCheckbox2
			key={mcd.label}
			fieldData={mcd.value}
			title={mcd.label}
			setValue={subSetValue(mcd.id)}
			isDisabled={isDisabled}
		/>
	));

	return (
		<>
			{title ? <Form.Label>{title}</Form.Label> : null}
			{checkBoxes}
		</>
	);
};

export const FieldCheckbox2 = ({
	isDisabled,
	error,
	fieldData,
	setValue = () => {},
	autoFocus,
	title = "",
}) => {
	const [boolValue, setBoolValue] = useState(fieldData || false);

	useEffect(() => {
		setBoolValue(fieldData);
	}, [fieldData]);

	return (
		<Form.Group data-testid="test-fieldCheckbox">
			<Form.Check.Input
				id={title}
				data-testid="test-fieldCheckboxInput"
				disabled={isDisabled}
				isInvalid={!!error}
				type="checkbox"
				style={{ marginTop: "3px" }}
				checked={!!boolValue}
				onChange={(e) => {
					setBoolValue((val) => !val);
					setValue(e.target.checked);
				}}
				autoFocus={autoFocus}
			/>
			<Form.Check.Label htmlFor={title} className="ps-2">
				{title}
			</Form.Check.Label>
		</Form.Group>
	);
};

export const FieldCheckbox = ({
	isDisabled,
	error,
	fieldData,
	setValue = () => {},
	autoFocus = false,
}) => {
	const [boolValue, setBoolValue] = useState(fieldData || false);

	const {
		fieldSetting: { title, tooltip },
	} = useContext(DataFormFieldContext);

	useEffect(() => {
		setBoolValue(fieldData);
	}, [fieldData]);

	return (
		<Form.Group data-testid="test-fieldCheckbox">
			<Form.Check.Input
				id={title}
				data-testid="test-fieldCheckboxInput"
				disabled={isDisabled}
				isInvalid={!!error}
				type="checkbox"
				style={{ marginTop: "3px" }}
				checked={!!boolValue}
				onChange={(e) => {
					setBoolValue((val) => !val);
					setValue(e.target.checked);
				}}
				autoFocus={autoFocus}
			/>
			<Form.Check.Label htmlFor={title} className="ps-2">
				{title}
				{tooltip ? <InfoToolTip tooltip={tooltip} /> : null}
			</Form.Check.Label>
			<Form.Control.Feedback type="invalid">
				{error}
			</Form.Control.Feedback>
		</Form.Group>
	);
};
